// Blocks Studio placed on a page (Phelipe 2026-10-17: "add a feature, a
// button or text anywhere on any page"): a note, a button or a card sits at
// the top or bottom of the page, or before/after a landmark — a heading, a
// button or a table — found by its words. Shared by the page (the blocks
// themselves) and the chat (the dashed preview before Approve).

import { findElementLandmark } from "./anchor_element"

export const norm = (s) => (s || "").replace(/\s+/g, " ").trim().toLowerCase()
const visible = (n) => !!n && n.getClientRects().length > 0
const ours = (n) => n.closest("#studio-bubble, #instant-feedback, #feedback-detail, [data-page-block], [data-studio-ghost], [data-page-blocks-target='holder'], [data-studio-spot-picker]")

// Every landmark on the page, in page order: {type, text, label, index, el}.
// The same words twice ("Save" in two places) count up: index 0, 1…
export function landmarks(root = document.querySelector("main") || document.body) {
  const out = []
  const push = (type, el, raw) => {
    const label = (raw || "").replace(/\s+/g, " ").trim()
    const text = norm(label)
    if (!text || text.length > 120) return
    out.push({ type, text, label, el })
  }
  root.querySelectorAll("h1, h2, h3").forEach((h) => { if (!ours(h) && visible(h)) push("heading", h, h.textContent) })
  root.querySelectorAll('button[type="submit"], a.bg-brand, button.bg-brand').forEach((b) => {
    if (ours(b) || !visible(b) || b.closest("tr, th, td")) return
    const t = (b.textContent || "").replace(/\s+/g, " ").trim()
    if (t && t.length < 40) push("button", b, t)
  })
  root.querySelectorAll("table").forEach((t) => {
    if (ours(t) || !visible(t)) return
    const th = t.querySelector("thead th")
    push("table", t, th ? (th.textContent.trim() || th.getAttribute("title") || "") : "")
  })
  const counts = {}
  out.forEach((l) => { const k = `${l.type}:${l.text}`; l.index = counts[k] || 0; counts[k] = l.index + 1 })
  return out
}

export function findLandmark(lm, root) {
  if (!lm || !lm.type) return null
  // Any block on the page, picked with the dot (2026-10-19): by its path, then by its words.
  if (lm.type === "element") return findElementLandmark(lm, root || document.querySelector("main") || document.body)
  const want = norm(lm.text)
  const idx = +lm.index || 0
  const all = landmarks(root).filter((l) => l.type === lm.type && l.text === want)
  return (all[idx] || all[0])?.el || null
}

// Puts `el` where `anchor` says; the bottom of the page when the landmark is
// gone. Returns the spot used.
export function placeBlock(el, anchor, { top, bottom, root } = {}) {
  const spot = anchor?.spot || "page_bottom"
  if (spot === "page_top" && top) { top.appendChild(el); return "page_top" }
  if ((spot === "before" || spot === "after") && anchor.landmark) {
    const target = findLandmark(anchor.landmark, root)
    if (target && target.parentNode) {
      if (spot === "before") target.parentNode.insertBefore(el, target)
      else target.parentNode.insertBefore(el, target.nextSibling)
      return spot
    }
  }
  if (bottom) { bottom.appendChild(el); return "page_bottom" }
  if (top) { top.appendChild(el); return "page_top" }
  return null
}
